export const NO_RESULTS_MESSAGE = "Nothing was found";
export const LOADING_MESSAGE = "Loading...";
